import { getDataPointsKey, getRelatedIds } from 'utils/helpers';
import { useCallback, useMemo } from 'react';
import fetchTopKeywords from 'utils/api/topKeywords.api';
import { useQuery } from 'react-query';

// TODO: use abort controller to cancel requests
const useTopKeywords = ({ enabled, data, paginateBy, controller }) => {
    const key = data ? getDataPointsKey(...getRelatedIds(data)) : null;

    const queryCallback = useCallback(
        () => fetchTopKeywords({ data, paginateBy }),
        [data, paginateBy],
    );

    // TODO: The way data points keys are constructed is wrong.
    // null values are important and so is the "has" property.
    const { data: results, ...restQuery } = useQuery(
        `KWS||${key}`,
        queryCallback,
        {
            enabled,
            cacheTime: Infinity,
            staleTime: Infinity,
        },
    );

    const topKeywords = useMemo(
        () =>
            results
                ? results.reduce((acc, { keyword }) => {
                      if (keyword) acc.push(keyword);
                      return acc;
                  }, [])
                : null,
        [results],
    );

    return { topKeywords, ...restQuery };
};

export default useTopKeywords;
